module.exports = __webpack_public_path__ + "static/media/logo.9cce09d6.png";